import { balanceDomain } from '@balance';
import { useQuery } from '@tanstack/react-query';

export const useLoadCostSettingsQuery = () => {
  return useQuery([balanceDomain.costSettingsResourceUrl], () => {
    return balanceDomain.costSettingsRepository.loadCostSettings();
  });
};
